module.exports = __webpack_public_path__ + "assets/979c476894f92bae1389d69185c1282f.mp3";